// ─────────────────────────────────────────────────────────
// Interaktionsmodus des Sprach-Assistenten — vom Mic-Toggle gewählt.
// 'visual' (Standard, bisheriges Verhalten): der Assistent führt sichtbar
// durch die App (Geister-Zeiger, open_view/tap_target).
// 'voice': er arbeitet still über Daten-Werkzeuge und öffnet UI nur, wenn
// ein Schritt sie zwingend braucht (Formular-Diktat, Bestätigung).
// Der Modus muss VOR dem Verbindungsaufbau feststehen (der ephemerale
// Gemini-Live-Token friert Prompt + Tools ein) — ein Wechsel während der
// Sitzung bedeutet Stopp + Neustart. Persistenz wie die Orb-Position in
// localStorage, damit der nächste Tap direkt im gewohnten Modus startet.
// ─────────────────────────────────────────────────────────
const KEY = 'levelupwerk:voice-interaction';

export type VoiceInteraction = 'visual' | 'voice';

export function getVoiceInteraction(): VoiceInteraction {
  try {
    return localStorage.getItem(KEY) === 'voice' ? 'voice' : 'visual';
  } catch {
    return 'visual';
  }
}

export function setVoiceInteraction(mode: VoiceInteraction): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch { /* Speicher voll/blockiert — Modus gilt dann nur für diese Sitzung nicht */ }
}
